export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref9567.2159cc2d.jpg";